
import {
    Box, TextField, FormControl, InputAdornment, InputLabel, Input, IconButton, Button,
    Typography, Select, MenuItem, FormHelperText, Alert, Checkbox
} from '@mui/material';
import { AccountCircleOutlined, Visibility, VisibilityOff, LockOutlined, Group } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch, } from 'react-redux';
import { set, uniqBy } from 'lodash';
import { Tabs } from '../../components/tabs';
import { Grid } from '../../components/table';
import { CONFIG } from '../../../config'
import axios from 'axios';
import { ToolBar } from '../../components/toolbar';
import { Modal } from '../../components/modal';
import { FormA } from '../../components/form';
import moment from 'moment';
import { getFormState } from '../../../helpers/form';
import dayjs from 'dayjs';
import { SelectA } from '../../components/form';
import {receiveUsers} from '../../../state/user/actions';

const {uniq} = require('lodash');
const API_HOST = CONFIG.modules['accounts'].host






export const ResourceAssignment = (props) => {
    const { roles, user, users, Designations, Departments, Languages, Districts, TaskTypes, Campaigns } = useSelector((state) => (state.user || {}))
    const userStore = useSelector((state) => (state.user || {}))
    const [campaign, setCampaign] = useState('')
    const [campaignMap, setCampaignMap] = useState({})
    const dispatch = useDispatch()


    const [tasks, setTasks] = useState([]);
    const [tasksMap, setTasksMap] = useState({});

    useEffect(() => {
        if (Campaigns) {
            setCampaignMap(Campaigns.reduce((a, c) => {
                a[c._id] = c
                return a;
            }, {}))
            setCampaign(Campaigns[0]._id)
        }
    }, [Campaigns])

    useEffect(()=> {
        if(campaign) {
            axios.get(API_HOST + `/tasks?campaign=${campaign}`).then((resp) => {
                if (resp.data && resp.data.success) {
                   setTasks(resp.data.tasks)
                }
            }).catch((e) => {
                console.log(e)
            })
        }
        
    }, [campaign])

    useEffect(()=>{
        
    },[])

    useEffect(()=> {
            if(tasks) {
                setTasksMap(tasks.reduce((a,e) => {
                    a[e.user._id] = e;
                    return a;
                },{}))
            }
    }, [tasks])

    useEffect(()=> {
        console.log('user roles', users)
    },[users])

    const handleUpdate = (checked,id,type) => {
          axios.put(API_HOST + '/update-assigned-roles', {
            type: checked?'push':'pull',
            id: id,
            assigned: type
        }).then((resp) => {
            if (resp.data && resp.data.success) {
                const userss = [...users].map((u)=>{
                    if(u._id === id) {
                        u.assignedRoles = [...resp.data.user.assignedRoles]
                    }
                    return u
                });
                console.log('from here all')
                dispatch(receiveUsers([...userss]))
            }
        }).catch((e) => {
            console.log(e)
        })
        
        // const newTasksMap = {...tasksMap}
        // const task = newTasksMap[id]
        // if(!task) {
        //     newTasksMap[id] = {
        //         user: id,
        //         assigned:[]
        //     }
        // }
        // if(checked) {
        //     newTasksMap[id].assigned.push(type)
        //     newTasksMap[id].assigned = uniq(newTasksMap[id].assigned)
        // } else {
        //     newTasksMap[id].assigned = [...(newTasksMap[id].assigned.filter(e=>e!=type))]
        // }
        // setTasksMap(newTasksMap)
        // axios.put(API_HOST + '/tasks', {
        //     campaign,
        //     user: id,
        //     assigned: newTasksMap[id].assigned
        // }).then((resp) => {
        //     if (resp.data && resp.data.success) {
               
        //     }
        // }).catch((e) => {
        //     console.log(e)
        // })
        
    }


    return (
        <>
            
            <Box>
                <Box sx={{ display: 'flex', width: '15%', mt: 3 }}>
                    <SelectA field={
                        {
                            type: 'select',
                            label: 'Campaign',
                            option: { key: 'Campaigns', value: '_id', label: 'name' },
                            name: 'campaign'
                        }
                    } data={{ Campaigns }} onChange={(name, value, multiple) => {
                        setCampaign(value)
                    }} value={campaign} />
                </Box>
                <Box>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box sx={{ width: '25%' }}><Typography variant='h6' sx={{ fontWeight: 'bold', textAlign: 'center' }}>Agents</Typography></Box>
                        <Box sx={{ display: 'flex', width: '75%', justifyContent: 'space-around' }}>
                            {
                                Array.isArray(TaskTypes) &&
                                TaskTypes.map((t, i) => {
                                    return (
                                        <Box key={i} sx={{ width: '18%', display: 'flex', justifyContent: 'center' }}>
                                            <Typography variant='p' sx={{ textAlign: 'center', fontWeight: 500, fontSize: '.9em'  }}>{t.name}</Typography>
                                        </Box>
                                    )
                                })
                            }
                        </Box>
                    </Box>
                    {
                        Array.isArray(users) &&
                        users.filter(uu=>true || (uu.roles || []).includes(process.env.REACT_APP_TELECALLER)).map((u, i) => {
                            return (<Box key={i} sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                                <Box sx={{ width: '25%', border: '1px solid #F3D55B', display: 'flex', borderRadius: 2, p: 2 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <Typography sx={{ color: '#0669BF', fontWeight: 'bold', textAlign: 'center',fontSize:'.9em' }}>{u.uuid}</Typography>
                                    </Box>
                                    <Box sx={{ ml: 2 }}>
                                        <Typography sx={{ fontWeight: 'bold',fontSize:'.9em' }}>{u.name}</Typography>
                                        {
                                            u.designation[0] && <Typography sx={{ fontSize: '.8em' }}>{u.designation[0].name || ''}</Typography>
                                        }

                                        <Typography sx={{ fontSize: '.8em' }}>{'Full Time Employee'}</Typography>
                                        {campaignMap[campaign] && <Typography sx={{ fontSize: '.8em' }}>{campaignMap[campaign].name}</Typography>}



                                    </Box>
                                </Box>
                                <Box sx={{ display: 'flex', width: '75%', justifyContent: 'space-around' }}>
                                    {
                                        Array.isArray(TaskTypes) &&
                                        TaskTypes.map((t, i) => {
                                            // const task = tasksMap[u._id];
                                            let assigned = false
                                            // if(task && Array.isArray(task.assigned)) {
                                            //     assigned = task.assigned.includes(t._id)
                                            // }
                                            // console.log(u.assignedRoles, t._id)
                                            if(Array.isArray(u.assignedRoles)) {
                                                assigned = u.assignedRoles.some(ar=>ar._id == t._id)
                                            }
                                            return (
                                                <Box key={i} sx={{ width: '18%', display: 'flex', justifyContent: 'center' }}>
                                                    <Checkbox sx={{
                                                        '& .MuiSvgIcon-root': { fontSize: 34 },
                                                        // color:'#F3D55B',
                                                        '&.Mui-checked': {
                                                            color: '#F28627',
                                                        },
                                                    }} 
                                                    onChange={(e)=> {
                                                        handleUpdate(e.target.checked,u._id, t._id)
                                                    }}
                                                    checked={assigned}
                                                    />
                                                </Box>
                                            )
                                        })
                                    }
                                </Box>
                            </Box>)
                        })

                    }
                </Box>
            </Box>

        </>
    )
}